import QueueableRequest from './QueueableRequest';
import { REQUEST_METHOD_POST } from '../../helpers/constants';
import { bindParamsToRoute } from '../../helpers/url';
import { MFA_INITIATE } from '../../config/api';
import ApiError from '../errors/ApiError';

export const isMfaError = (err) => {
  if (!(err instanceof ApiError)) {
    return false;
  }
  return /89\d{2}/.test(err.code);
};

export default class MfaInitiateRequest extends QueueableRequest {
  constructor(msisdn, mfaToken, mfaMethod = 'tan_111111_test') {
    super(bindParamsToRoute(MFA_INITIATE, { msisdn }), {
      method: REQUEST_METHOD_POST,
      headers: {
        'X-Multifactor-Token': mfaToken,
      },
      payload: {
        mfaMethod,
      },
    });
  }

  isPreventDefaultErrorHandling(err) {
    return isMfaError(err);
  }
}
